import { useState, useRef, useEffect } from "react";

const AutoResizeTextarea = ({ value, onChange, onBlur, placeholder = "Введіть текст", className = "default-textarea" }) => {
  const [editing, setEditing] = useState(false);
  const textareaRef = useRef(null);

  // Функція для автоматичного підлаштування висоти
  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto"; // Скидаємо висоту
      textarea.style.height = `${textarea.scrollHeight}px`; // Встановлюємо висоту під контент
    }
  };

  useEffect(() => {
    if (editing) {
      adjustHeight();
    }
  }, [value, editing]);

  return editing ? (
    <textarea
      ref={textareaRef}
      className={className}
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
        adjustHeight();
      }}
      onBlur={() => {
        setEditing(false);
        onBlur();
      }}
      autoFocus
      placeholder={placeholder}
      rows="1"
      style={{
        width: "100%",
        resize: "none",
        overflow: "hidden",
        fontFamily: "inherit",
        outline:"none",
        padding:0
      }}
    />
  ) : (
    <p
      onClick={() => setEditing(true)}
      style={{
        cursor: "pointer",
        wordBreak: "break-word"
      }}
      className={className}
    >
      {value || placeholder}
    </p>
  );
};

export default AutoResizeTextarea;